import { Slider } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from './AgeSlider.module.css';

export const AgeSlider = ({
  disabled,
  defaultValue,
  onAfterChange,
  resetToDeafults,
  minAge = 18,
  maxAge = 100,
}: {
  disabled: boolean;
  minAge?: number;
  maxAge?: number;
  defaultValue: [number, number];
  onAfterChange: (ageRange: [number, number]) => void;
  resetToDeafults?: boolean;
}) => {
  const baseAge: [number, number] = [minAge, maxAge];
  const baseValue = defaultValue || baseAge;
  const [age, setAge] = useState<[number, number]>(baseValue);

  useEffect(() => {
    if (resetToDeafults) {
      setAge(baseAge);
    }
  }, [resetToDeafults]);

  return (
    <div className={styles.container}>
      <Slider
        rootClassName={styles.slider}
        min={minAge}
        max={maxAge}
        step={1}
        range={{ draggableTrack: true }}
        tooltip={{
          placement: 'bottom',
          open: true,
          getPopupContainer: element =>
            element.parentElement ? element.parentElement : document.body,
        }}
        trackStyle={[{ backgroundColor: 'var(--color-geekblue-6' }]}
        railStyle={{ backgroundColor: '#CDDEF7' }}
        onChange={ageRange => setAge(ageRange)}
        disabled={disabled}
        value={age}
        onAfterChange={ageRange => onAfterChange(ageRange)}
      />
    </div>
  );
};
